import {StyleSheet} from 'react-native';

import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const SPIN_LOGO_SIZE = spacing.m;

export const styles = createThemedStyles(theme => ({
  container: {
    gap: spacing.xs,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  spinButton: {
    padding: 0,
    width: SPIN_LOGO_SIZE,
    height: SPIN_LOGO_SIZE,
    borderRadius: SPIN_LOGO_SIZE / 2,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinLogo: {
    width: '100%',
    height: '100%',
  },
  rewind: {
    position: 'absolute',
  },
  rewindIcon: {
    color: theme.colors.borderColor,
  },
}));
